import { Button, Icon } from '@mui/material'
import Grid from '@mui/material/Grid'
import classNames from 'classnames'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './PopoverCloseButton.module.less'

type PopoverCloseButtonProps = {
  handleClose: () => void
}

export default function PopoverCloseButton({ handleClose }: PopoverCloseButtonProps): ReactElement {
  const { t } = useTranslation()

  return (
    <Grid>
      <Button
        onClick={handleClose}
        className={styles.PopoverCloseButton_CloseButton}
        data-testid="dialog-close-button" // e2e: locale-independent close button selector — do not remove
      >
        {t(`Close`)}
        <Icon fontSize="inherit" className={classNames(`fal fa-times`, styles.PopoverCloseButton_CloseIcon)} />
      </Button>
    </Grid>
  )
}
